export const fieldNames = {
  surName: 'surName',
  firstName: 'firstName',
  patrName: 'patrName',
  phone: 'phone',
  email: 'email',
  isOwner: 'isOwner',
};

export const nameFieldNames = [
  fieldNames.surName,
  fieldNames.firstName,
  fieldNames.patrName,
];

export const PHONE_LENGTH = 10;

export const defaultValues = {
  [fieldNames.surName]: '',
  [fieldNames.firstName]: '',
  [fieldNames.patrName]: '',
  [fieldNames.phone]: '',
  [fieldNames.email]: '',
  [fieldNames.isOwner]: true,
};
